import {
    HIDE_LOADING,
    SHOW_LOADING,
    HIDE_TOAST,
    SHOW_TOAST
} from './type'

//定义state 用来控制界面中的显示与隐藏
const state = {
    loading: false,
    toastshow: false,
    toastMsg: "111111",
    "path": "pickupStation",
    "cityAddress": true,
    map: {},
    "currentPoint": "",
    defaultIndex: "接站",
    cityNo: "50010",
};
//定义事件
const mutations = {
    /*loading*/
    [HIDE_LOADING](state) {
        state.loading = false;
    },
    [SHOW_LOADING](state) {
        state.loading = true;
    },
    [HIDE_TOAST](state) {
        state.toastshow = false;
    },
    [SHOW_TOAST](state) {
        state.toastshow = true;
    },
};

const getters = {
    loading(state) {
        return state.loading;
    },
    toastshow(state) {
        return state.toastshow;
    },
    toastMsg(state) {
        return state.toastMsg;
    }
};

export default {
    state,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/mutations.js